import { createSlice } from "@reduxjs/toolkit";
import {     reKyc_digio_requestThunk } from "./thunk";

export const initialState = {
  reKyc_digio_requestData: [],
  reKyc_digio_requestError: '', // for error message
  reKyc_digio_requestLoading: false,
  
  
};

const Re_Kyc_Digio_Request = createSlice({
  name: "Re_Kyc_Digio_Request",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_digio_requestThunk.pending, (state) => {
      state.reKyc_digio_requestLoading = true ;
      state.reKyc_digio_requestData= [];
      state.reKyc_digio_requestError='';

  });
    builder.addCase(reKyc_digio_requestThunk.fulfilled, (state, action) => {
        state.reKyc_digio_requestData = action.payload.data;
        state.reKyc_digio_requestLoading = false ;
    });
    builder.addCase(reKyc_digio_requestThunk.rejected, (state, action) => {
      state.reKyc_digio_requestError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_digio_requestLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Re_Kyc_Digio_Request.actions

export default Re_Kyc_Digio_Request.reducer;